(function ($) {

    $(document).on( 'click', '.menu-item-has-children', function() {

        if($(this).hasClass('open')){
            $(this).removeClass('open');
        } else {
            $(this).addClass('open');
        }

    });

    $(document).on( 'click', '#menu-toggler', function() {

        if($(this).hasClass('open')){
            $(this).removeClass('open');
            //$('html').removeClass('noscroll');
            $('#primary-nav').removeClass('nav-open');
        } else {
            $(this).addClass('open');
            //$('html').addClass('noscroll');
            $('#primary-nav').addClass('nav-open');
        }

    });


    $(document).ready(function() {

        //START hide menu on scroll down and display when scroll up
        var ver_scroll_header;

        $(window).scroll(function(event) {
            ver_scroll_header = true;
        });

        setInterval(function() {
            if (ver_scroll_header) {
                hasScrolled_header();
                ver_scroll_header = false;
            }
        }, 250);

        function hasScrolled_header() {

            var position = $(this).scrollTop();

            if(position < 10){
                $('#masthead').removeClass('not-at-top');
            } else{
                $('#masthead').addClass('not-at-top');
            } 
        }


    });



})
(jQuery);